<template>
  <f7-card class="pg-expandable-card card-raised" expandable>
    <f7-card-content :padding="false">
      <div class="pg-expandable-card-wrapper" :class="colorClass" :style="{ height: heightPx }">
        <f7-card-header :text-color="textColor" class="display-block">
          <slot name="title"></slot>
          <br />
          <small :style="{ opacity: 0.7 }">
            <slot name="subtitle"></slot>
          </small>
        </f7-card-header>
        <f7-link
            card-close
            :color="textColor"
            class="card-opened-fade-in card-close-btn"
            icon-f7="xmark_circle_fill"
        ></f7-link>
      </div>
      <div class="card-content-padding">
        <slot name="content"></slot>
      </div>
    </f7-card-content>
  </f7-card>
</template>

<script>

  export default {
    components: {},

    props: {
      colorClass: {default: 'bg-brand-green'},
      textColor: {default: 'white'},

      // The collapsed height of the card. The component was built to take one
      // and the wiring was never finished: the template hardcoded '300px' while
      // this default said '200px', so the prop was declared and never read.
      //
      // The default is '300px' rather than the declared-but-dead '200px' on
      // purpose — that is the height every caller has actually been rendering,
      // so finishing the wiring is a pure capability addition and changes no
      // shipped screen.
      heightPx: {default: '300px'},
    },

    mixins: [],

    data: function () {
      return {
        //
      };
    },

    computed: {
      //
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      //
    },

    watch: {
      //
    }
  };
</script>
<style lang="scss">
  .pg-expandable-card.card-expandable {
      box-shadow: 0 5px 10px rgba(0, 0, 0, .3);

    .pg-expandable-card-wrapper {
      height: 600px;
    }

    &.card-opened .pg-expandable-card-wrapper {
      padding-top: env(safe-area-inset-top, 20px);
    }

    .card-close-btn {
      position: absolute;
      right: 15px;
      top: calc(15px + env(safe-area-inset-top, 20px));
    }
  }
</style>
